export default {
    general: {
        add: 'Dodaj', edit: 'Uredi', cancel: 'Prekliči', save: 'Shrani', search: 'Išči',
        close: 'Zapri', delete: 'Izbriši', confirm: 'Potrdi', yes: 'DA', no: 'NE',
        loading: 'Nalaganje ...', actions: 'Akcije', back: 'Nazaj', copy: 'Kopiraj',
        copied: 'Kopirano', none: '—',
    },
    errors: {
        too_many_attempts: 'Preveč poskusov. Počakajte trenutek in poskusite znova.',
        generic_error: 'Prišlo je do napake', invalid_data: 'Neveljavni podatki',
        not_found: 'Ni najdeno', unauthorized: 'Nimate dovoljenja',
        incorrect_status: 'Dejanje v tem stanju ni mogoče',
        on_edit: 'Napaka pri shranjevanju', login_failed: 'Prijava ni uspela',
        network: 'Povezava s strežnikom ni uspela.',
        stale_build: 'Konzola je bila medtem posodobljena. Osvežite stran (Cmd/Ctrl + R).',
    },
    success: { add: 'Uspešno dodano', edit: 'Uspešno shranjeno', deleted: 'Uspešno izbrisano' },
    about: {
        title: 'O aplikaciji', version: 'Različica',
        tagline: 'Centralna konzola za on-prem ComplyIT',
        changelog: 'Dnevnik sprememb', powered_by: 'Razvija',
    },
    nav: {
        menu: 'Meni',
        tagline: 'VENDOR CONSOLE', overview: 'PREGLED', settings_group: 'UPRAVLJANJE',
        dashboard: 'Nadzorna plošča', customers: 'Stranke', instances: 'Instance', users: 'Uporabniki',
        billing_group: 'OBRAČUN', plans: 'Paketi', releases: 'Izdaje', billing: 'Obračun',
        settings: 'Nastavitve',
        remote_access: 'Oddaljen dostop', mailboxes: 'E-predali', mail: 'Pošta', support: 'Podpora',
        help: 'Pomoč', logout: 'Odjava',
    },
    remote: {
        title: 'Oddaljen dostop',
        subtitle: 'Seje dostopa do strankinih naprav.',
        waiting: 'Čaka na odgovor',
        open_now: 'Odprto zdaj',
        history: 'Zgodovina',
        empty: 'Sej še ni.',
        asked_by: '{who}, {when}',
        up_to: 'do {minutes} min',
        approved_by: 'odobril {who}',
        expires: 'poteče {when}',
        remaining: 'še {left}',
        used: '{n} povezav',
        not_used: 'brez povezave',
        approve: 'Odobri',
        deny: 'Zavrni',
        end: 'Prekini',
        approve_intro: 'Odobritev odpre pot do naprave {instance}. Operater je privolil v največ {minutes} minut.',
        grant_minutes: 'Odobreno trajanje (minut)',
        grant_hint: 'Sejo lahko skrajšate, nikoli podaljšate — zgornja meja {minutes} min pripada stranki.',
        public_key: 'Vaš javni ključ SSH',
        public_key_hint: 'Naprava ga vstavi za čas seje in ga ob koncu odstrani. Zapomni se lokalno, da ga ne lepite vsakič.',
        approved: 'Seja odobrena.',
        denied: 'Prošnja zavrnjena.',
        ended: 'Seja prekinjena.',
        col_instance: 'Naprava',
        col_state: 'Stanje',
        col_asked: 'Zaprosil',
        col_decided: 'Odločil',
        col_used: 'Povezav',
        state_requested: 'zahtevana',
        state_approved: 'odobrena',
        state_active: 'aktivna',
        state_denied: 'zavrnjena',
        state_ended: 'končana',
        state_expired: 'potekla',
        public_key_optional: 'Prazno uporabi ključ iz nastavitev konzole. Izpolnite le, če želite tokrat drugega.',
        on_host: 'na {host}',
        waiting_appliance: 'Čaka na napravo — javi se ob naslednjem preverjanju.',
        on_host_note: 'Če delaš na {host}, zadošča: ssh -p {port} complyit@127.0.0.1',
    },
    mail: {
        title: 'Pošta',
        compose: 'Sestavi',
        not_configured: 'E-pošta ni nastavljena. Skrbnik naj v datoteki .env na strežniku vpiše poverilnice predalov (INFO_MAILBOX/INFO_PASSWORD in SUPPORT_MAILBOX/SUPPORT_PASSWORD).',
        total: 'skupaj {n}',
        from: 'Od', to: 'Za', subject: 'Zadeva', date: 'Datum', body: 'Sporočilo',
        no_subject: '(brez zadeve)',
        empty: 'Ni sporočil.',
        empty_body: '(prazno sporočilo)',
        newer: 'Novejša', older: 'Starejša',
        reply: 'Odgovori', delete: 'Izbriši', send: 'Pošlji',
        sent: 'Sporočilo poslano',
        send_failed: 'Pošiljanje ni uspelo',
        confirm_delete: 'Premaknem to sporočilo v koš?',
    },
    support: {
        title: 'Podpora',
        refresh: 'Osveži',
        not_configured: 'Predal za podporo ni nastavljen. Skrbnik naj v datoteki .env na strežniku vpiše SUPPORT_MAILBOX in SUPPORT_PASSWORD.',
        status: 'Status', subject: 'Zadeva', customer: 'Stranka', messages: 'Sporočila',
        last_activity: 'Zadnja aktivnost',
        no_customer: 'Ni povezana',
        empty: 'Ni prijav.',
        status_new: 'Nova', status_open: 'Odprta', status_closed: 'Zaprta',
        mark_open: 'Označi odprto', mark_closed: 'Zapri', reopen: 'Ponovno odpri',
        you: 'Vi',
        reply_label: 'Odgovor',
        reply_placeholder: 'Vaš odgovor …',
        send_reply: 'Pošlji odgovor',
    },
    settings: {
        title: 'Nastavitve', subtitle: 'Nastavitve konzole ComplyIT Admin.',
        email_section: 'E-pošta (SMTP)',
        email_hint: 'Odhodni SMTP strežnik za obveščanje. Zaenkrat se pošta pošlje le prek gumba za testno sporočilo (temelj za prihodnja opozorila).',
        smtp_host: 'Gostitelj (host)', smtp_port: 'Vrata', smtp_user: 'Uporabnik',
        smtp_password: 'Geslo', smtp_from: 'Naslov pošiljatelja (from)',
        password_set_hint: 'Geslo je nastavljeno. Pustite prazno = nespremenjeno.',
        password_empty_hint: 'Geslo ni nastavljeno. Pustite prazno = nespremenjeno.',
        test_send: 'Pošlji testno sporočilo',
        test_recipient: 'Prejemnik', send_test: 'Pošlji testno sporočilo',
        test_sent: 'Testno sporočilo poslano', test_failed: 'Pošiljanje testnega sporočila ni uspelo',
        redirect_section: 'Testna preusmeritev e-pošte',
        redirect_hint: 'Varovalka za testna okolja. Velja SAMO za pošto instanc — registracijska pošta konzole (potrditev in pozdrav) gre vedno pravemu prejemniku.',
        redirect_field: 'Preusmeri vso pošto instanc na naslov',
        redirect_field_hint: 'Prazno = preusmeritev izklopljena. Ne vpliva na registracijsko pošto konzole.',
        redirect_active_warning: 'Vse ComplyIT instance, ki se javljajo tej konzoli, bodo VSO izhodno pošto preusmerile na {email} — varovalka za testna okolja.',
        ai_rate_section: 'Cenik AI (privzeti)',
        ai_rate_hint: 'Globalni privzeti cenik za obračun porabe AI žetonov. Velja za vse stranke brez lastnega cenika.',
        ai_price_input: 'Cena vhod (€ / 1M)', ai_price_output: 'Cena izhod (€ / 1M)',
        ai_rate_field_hint: 'Cena na 1.000.000 žetonov. Konzola s tem cenikom obračuna porabo instanc.',
        ai_key_section: 'AI ključ (upravlja ponudnik)',
        ai_key_hint: 'Ključ Anthropic hrani konzola in ga ob javljanju (check-in) dostavi instancam. Ker porabo AI merimo in zaračunavamo mi, mora biti ključ NAŠ — stranke ga ne vpisujejo več same.',
        ai_enabled: 'AI vklopljen za vse instance',
        ai_enabled_hint: 'Glavno stikalo. Izklop takoj ustavi dostavo ključa vsem instancam (ob naslednjem javljanju).',
        ai_api_key: 'Ključ Anthropic API',
        ai_key_set_hint: 'Ključ je nastavljen. Prazno = nespremenjeno, »-« = izbriši.',
        ai_key_empty_hint: 'Ključ ni nastavljen. Prazno = nespremenjeno, »-« = izbriši.',
        ai_model: 'Privzeti model',
        ai_model_hint: 'Model, ki ga dobijo instance brez lastne izbire. Izberite s seznama ali vpišite ID modela; prazno = {model}. Cena porabe je ena za vse modele (zgoraj).',
        ai_no_key_warning: 'AI je vklopljen, a ključ ni nastavljen — instance ne bodo dobile ničesar in AI pri strankah ne bo deloval.',
        ai_off_warning: 'AI je izklopljen: nobena instanca ne dobi ključa, tudi če je vpisan.',
        usage_section: 'Opozorila o porabi (paketi)',
        usage_hint: 'Ko poraba stranke preseže omejitve njenega paketa (ali se jim približa na 80 %), konzola opozori NAS. Opozorilo se pošlje ob prehodu v stanje, največ eno na stranko na 7 dni.',
        usage_alert_email: 'Naslov za opozorila ponudniku',
        usage_alert_email_hint: 'Prazno = support@comply-it.net. To je naš naslov, ne strankin.',
        usage_customer_emails: 'Dovoli e-pošto strankam s predlogom nadgradnje',
        usage_customer_emails_hint: 'Glavno stikalo, privzeto IZKLOPLJENO. Tudi ko je vklopljeno, sporočilo prejmejo le stranke, ki imajo privolitev vklopljeno posamično (Stranke → uredi → Avtomatika).',
        usage_customer_emails_warning: 'Pošiljanje e-pošte strankam je dovoljeno. Sporočilo bodo prejele samo stranke z lastno privolitvijo.',
        public_section: 'Javne strani in e-pošta',
        public_hint: 'Podatki, ki se prikažejo na javnih straneh registracije in v pozdravni e-pošti.',
        support_phone: 'Telefon za podporo',
        support_phone_hint: 'Prazno = vrstica se v e-mailih skrije.',
        vm_download_url: 'Povezava za prenos VM slike',
        vm_download_url_hint: 'Prazno = razdelek se skrije.',
        enroll_section: 'Žeton za samoprijavo (appliance)',
        enroll_hint: 'Skupni skrivni žeton, vgrajen v pripravljeno VM sliko. Ob prvem zagonu se instanca z njim samoprijavi konzoli in se pojavi med nezahtevanimi. Ustvari se samodejno.',
        enroll_token: 'Žeton za samoprijavo',
        enroll_rotate_warning: 'Zamenjava žetona takoj razveljavi starega — pripravljene VM slike s starim žetonom se ne bodo več mogle samoprijaviti (potrebna ponovna gradnja slike).',
        enroll_rotate: 'Rotiraj', enroll_rotated: 'Žeton za samoprijavo zamenjan',
        enroll_rotate_confirm: 'Star žeton bo takoj prenehal veljati; VM slike z njim se ne bodo mogle samoprijaviti. Nadaljujem?',
        support_key_title: 'Ključ za oddaljeno podporo',
        support_key_hint: 'Javni ključ SSH, ki ga naprava vstavi za čas seje in ga ob koncu odstrani. Nastavljen tu, da odobritev seje ne zahteva lepljenja. Zasebna polovica je na tem strežniku, poleg prenosnika.',
        support_key_field: 'Javni ključ SSH',
        support_jump_field: 'Gostitelj za preskok',
        support_jump_hint: 'Kje vstopi ssh — stroj, na katerem teče prenosnik, v obliki uporabnik@gostitelj. Prikaže se v ukazu za povezavo.',
    },
    ai_models: {
        sonnet: 'uravnotežen, privzet',
        opus: 'najzmogljivejši, najdražji',
        haiku: 'najhitrejši, najcenejši',
        fable: 'najnovejši',
        custom: 'vpisan ročno',
    },
    help: {
        title: 'Pomoč', subtitle: 'Navodila za uporabo konzole ComplyIT Admin.',
    },
    login: {
        username: 'Uporabniško ime', password: 'Geslo', submit: 'Prijava',
        subtitle: 'Centralna vendor konzola',
        or: 'ali',
        passkey: 'Prijava s passkeyem',
        passkey_failed: 'Prijava s passkeyem ni uspela.',
    },
    passkeys: {
        title: 'Passkeyi',
        hint: 'Prijava brez gesla s Touch ID, Windows Hello ali varnostnim ključem.',
        add: 'Dodaj passkey',
        label: 'Ime naprave',
        empty: 'Ni registriranih passkeyev.',
        created: 'Ustvarjen',
        last_used: 'Nazadnje uporabljen',
        added: 'Passkey je dodan.',
        failed: 'Registracija passkeya ni uspela.',
        confirm_delete: 'Res izbrišem passkey »{label}«?',
    },
    dashboard: {
        title: 'Nadzorna plošča', subtitle: 'Pregled strank, instanc in prihodkov.',
        kpi_customers: 'Stranke', kpi_instances: 'Instance',
        kpi_outdated: 'Zastarele instance', kpi_stale: 'Nedosegljive instance',
        kpi_servers_warning: 'Strežniki v opozorilu', kpi_mrr: 'Mesečni prihodek (MRR)',
        kpi_over_plan: 'Stranke čez paket',
        kpi_over_plan_hint: 'Čez paket: {over} (od tega v 30-dnevnem odlogu, kjer še nič ni omejeno: {grace}) · blizu meje: {near} · preplačuje: {underused}',
        recent_instances: 'Instance', health: 'Zdravje', no_data: 'Ni podatkov.',
        stale_alert_title: 'Nedosegljivih instanc: {count}',
        stale_alert_hint: 'Te instance se že dlje niso javile (check-in). Preverite povezljivost ali stanje storitve.',
        version_distribution: 'Porazdelitev verzij', health_distribution: 'Porazdelitev zdravja',
        below_target: 'ni na globalni ciljni izdaji',
        global_target_is: 'Globalna ciljna izdaja: {version}', no_global_target: 'Globalna ciljna izdaja ni nastavljena.',
        instances_without_target: '{count} instanc nima ciljne različice in se nikoli ne bo nadgradilo. Nastavite globalno ciljno izdajo ali vsaki pripnite različico.',
        view_all: 'Poglej vse',
    },
    filters: {
        search: 'Iskanje', search_placeholder: 'Ime instance ali stranke',
        customer: 'Stranka', version_status: 'Stanje verzije', health: 'Zdravje',
        all: 'Vse', uptodate: 'Ažurno', outdated: 'Zastarelo', clear: 'Počisti',
        more: 'Več filtrov',
    },
    customers: {
        title: 'Stranke', new: 'Nova stranka', edit: 'Uredi stranko', name: 'Naziv',
        contact_email: 'Kontaktni e-naslov', tax_number: 'Davčna številka', country: 'Država', notes: 'Opombe',
        plan: 'Paket', no_plan: 'Brez paketa', confirm_delete: 'Res izbrišem to stranko?',
        plans: 'Paketi (naročnina)',
        merged_preview: 'Skupaj podeljeno',
        merged_total: 'Mesečno skupaj',
        merged_family_hint: 'Številčne omejitve se združujejo ZNOTRAJ režima: omejitve paketa CRA ne dvignejo omejitev NIS2 (in obratno). Zmožnost AI velja, če jo podeljuje katerikoli paket.',
        confirm_delete_cascade: 'Ta stranka ima {count} instanc — izbrisane bodo tudi te (skupaj z njihovimi namestitvenimi žetoni). Res izbrišem stranko? Tega ni mogoče razveljaviti.',
        mailbox: 'E-predal (comply-it.net)', no_mailbox: 'Predal še ni ustvarjen.',
        create_mailbox: 'Ustvari predal', mailbox_created: 'E-predal ustvarjen',
        mailbox_failed: 'E-predala ni bilo mogoče ustvariti. Poskusite znova z gumbom »Ustvari predal«.',
        ai_rate_section: 'Cenik AI (za to stranko)',
        ai_price_input: 'Cena vhod (€ / 1M)', ai_price_output: 'Cena izhod (€ / 1M)',
        ai_rate_default: 'privzeto',
        ai_rate_hint: 'Neobvezno. Prazno = velja globalni privzeti cenik. Vnesena vrednost prepiše privzeti cenik za to stranko.',
        ai_key_section: 'AI ključ (za to stranko)',
        ai_api_key: 'Lasten ključ Anthropic API',
        ai_key_set_hint: 'Stranka ima lasten ključ. Prazno = nespremenjeno, »-« = izbriši (velja ključ ponudnika).',
        ai_key_empty_hint: 'Lastnega ključa ni — velja ključ ponudnika. Prazno = nespremenjeno.',
        ai_model: 'Lasten model',
        ai_model_default: 'privzeti model ponudnika',
        ai_model_hint: 'Prazno = privzeti model iz Nastavitev. Lahko vpišete tudi ID modela, ki ga ni na seznamu.',
        ai_key_hint: 'Lasten ključ je smiseln, kadar ga je treba preklicati brez posega v celotno floto. Sicer pustite prazno.',
        ai_column: 'AI ključ',
        ai_state_own: 'Lasten ključ',
        ai_state_vendor: 'Ključ ponudnika',
        ai_state_off: 'Izklopljeno',
        trial_until: 'preizkus do {date}', limited: 'omejeno',
        filter_plan: 'Paket', filter_all_plans: 'Vsi paketi',
        none_on_plan: 'Na izbranem paketu ni nobene stranke.',
        upgrade_requested: 'Zahtevana nadgradnja na {plan}, {date}',
        upgrade_requested_from: 'Zahtevek je poslala instanca {instance}',
        upgrade_requested_hint: 'Zahtevek se samodejno umakne, ko stranki dodelite izbrani paket in shranite. Omejitve se na instanci sprostijo ob njenem naslednjem javljanju.',
        upgrade_dismiss: 'Umakni',
        upgrade_dismissed: 'Zahtevek umaknjen',
    },
    profile: {
        title: 'Moj profil', name: 'Ime', email: 'E-naslov', language: 'Jezik',
        change_password: 'Sprememba gesla',
        change_password_hint: 'Pustite prazno, če gesla ne želite spremeniti.',
        current_password: 'Trenutno geslo', new_password: 'Novo geslo', confirm_password: 'Potrdi novo geslo',
        password_mismatch: 'Novi gesli se ne ujemata.',
        wrong_password: 'Napačno trenutno geslo.',
    },
    mailboxes: {
        title: 'E-predali', subtitle: 'Upravljanje e-predalov na domeni {domain} (Mailcow).',
        new: 'Nov predal', address: 'Naslov', name: 'Ime', quota: 'Kvota (poraba / skupaj)',
        created: 'Ustvarjen', empty: 'Ni predalov.',
        not_configured: 'Povezava z Mailcow ni nastavljena. Nastavite MAILCOW_URL in MAILCOW_API_KEY v okolju admin-api.',
        local_part: 'Lokalni del (pred @)', display_name: 'Prikazno ime',
        created_ok: 'Predal {address} je ustvarjen.',
        password_once: 'Geslo (prikazano samo enkrat)',
        password_warning: 'Geslo si shranite zdaj — pozneje ga ni več mogoče prikazati.',
        confirm_delete: 'Res izbrišem predal {address}? Tega ni mogoče razveljaviti.',
    },
    instances: {
        title: 'Instance', new: 'Nova instanca', customer: 'Stranka', name: 'Ime',
        version: 'Verzija', target: 'Ciljna', outdated: 'zastarelo', uptodate: 'ažurno', not_installed: 'Ni nameščeno',
        frontend_version: 'Frontend verzija', backend_version: 'Backend verzija',
        version_mismatch: 'Frontend in backend verziji se razlikujeta',
        resources: 'Uporabljeni viri', counts: 'Števci', last_checkin: 'Zadnji check-in',
        checkin_ip: 'IP (zadnje javljanje)',
        arch: 'Arhitektura',
        access_local_only: '· dosegljivo v omrežju stranke',
        access_none: 'Instanca še ni javila naslova.',
        no_target: 'brez cilja',
        last_delivered: 'Nazadnje sporočeno',
        target_pending_hint: 'Ta instanca trenutnega cilja še ni prejela — dobi ga ob naslednjem javljanju (do 15 minut). Konzola in instanca si NISTA v nasprotju; instanca po spremembi cilja preprosto še ni vprašala.',
        no_target_hint: 'Ta instanca nima ciljne različice: ni pripeta in ni globalne ciljne izdaje, ki bi jo lahko podedovala. Nikoli se ne bo nadgradila, dokler ne nastavite globalne ciljne izdaje (ali ji pripnete različice).',
        target_arch_fallback: 'Globalna ciljna izdaja nima slike za to arhitekturo, zato je izbrana najnovejša izdaja, ki jo ta instanca zares zna pognati.',
        arch_unknown: 'neznana',
        arch_unknown_hint: 'Ta instanca še ne javlja svoje arhitekture procesorja, zato konzola ne more preveriti, ali ciljna izdaja sploh ima sliko, ki jo zna pognati.',
        health: 'Zdravje', detail: 'Podrobnosti instance', set_target: 'Nastavi ciljno verzijo',
        target_version: 'Ciljna verzija', target_hint: 'Prazno = uporabi globalno ciljno izdajo',
        target_global_option: '— globalna ciljna izdaja —', target_is_global: 'globalna ciljna',
        regenerate_key: 'Regeneriraj API ključ',
        regenerate_confirm: 'Star ključ bo takoj prenehal veljati. Nadaljujem?',
        danger_zone: 'Nevarno območje',
        delete: 'Izbriši instanco',
        delete_hint: 'Trajno izbriše to instanco in vse pripadajoče namestitvene žetone. Tega ni mogoče razveljaviti.',
        delete_confirm: 'Res trajno izbrišem to instanco? Izbrisani bodo tudi njeni namestitveni žetoni. Tega ni mogoče razveljaviti.',
        api_key_once: 'Ta ključ je prikazan samo enkrat — shranite ga zdaj.',
        incidents: 'Incidenti', reports: 'Poročila', users: 'Uporabniki', companies: 'Podjetja',
        never: 'Nikoli', select_customer: 'Izberi stranko', created_key: 'Instanca ustvarjena. API ključ:',
        new_key_created: 'Nov API ključ:', stale: 'nedosegljiva', online: 'na zvezi',
        containers: 'Kontejnerji',
        container_warning: 'Nekateri kontejnerji ne tečejo, so nezdravi ali so se že restartali',
        upgrade_history: 'Zgodovina nadgradenj', upgrade_when: 'Datum/čas', upgrade_version: 'Verzija',
        upgrade_backend: 'Backend', upgrade_empty: 'Še ni zabeleženih nadgradenj.',
        force_update: 'Nadgradi zdaj',
        force_update_confirm: 'Instanca bo ob naslednjem javljanju pozvana k takojšnji nadgradnji na ciljno verzijo. Nadaljujem?',
        force_update_started: 'Zahteva za nadgradnjo zabeležena — čakam na javljanje instance.',
        force_update_waiting: 'Čaka na javljanje instance …',
        force_update_hint: 'Na voljo, dokler je instanca zastarela. Zastavica se počisti, ko se instanca javi s ciljno verzijo (ali po 24 h).',
        sources_error: 'viri!',
        sources_error_tooltip: 'Vsaj en omogočen konektor javlja napako sinhronizacije',
        os_updates_short: 'OS: {n}', os_reboot_short: 'zagon', os_reboot_needed: 'Potreben ponovni zagon',
        unclaimed: 'Nezahtevana',
        upgrade_open_customer: 'Odpri stranko',
        unclaimed_badge: 'Nezahtevane: {n}', unclaimed_badge_tooltip: 'Prikaži samo nezahtevane instance (samoprijavljene, še brez stranke)',
        unclaimed_tooltip: 'Samoprijavljena instanca, ki še ni dodeljena stranki',
        claim_title: 'Nezahtevana instanca', claim_action: 'Dodeli stranki',
        claim_hint: 'Ta instanca se je samoprijavila in še ni dodeljena stranki. Do dodelitve se javlja pogosteje in ne dobi upravičenj.',
        claim_existing: 'Obstoječa stranka', claim_new: 'Nova stranka', claim_new_name: 'Naziv nove stranke',
        claim_plan: 'Paket (neobvezno)', claim_plan_none: 'Brez paketa', claim_plan_hint: 'Neobvezno. Če izberete paket, se stranki nastavi ta paket ob dodelitvi.',
        claim_done: 'Instanca dodeljena stranki',
    },
    modules: {
        title: 'Moduli (regulativni režimi)',
        source_local: 'Lokalna nastavitev',
        local_warning: 'Moduli na tej instanci so nastavljeni LOKALNO, ne iz paketa. To pomeni, da si je skrbnik instance režim vklopil sam. Nastavite module na strankinem paketu — prva naslednja javljanja jih povozijo in to opozorilo izgine.',
        console_hint: 'Moduli prihajajo iz strankinega paketa.',
    },
    pairing: {
        generate: 'Poveži napravo',
        generate_confirm: 'Ustvarim novo kodo za povezavo? Ko napravo povežete s to kodo, se ključ instance zamenja — če instanca že teče, se bo nehala javljati, dokler je znova ne povežete. Sámo ustvarjanje kode delujoče instance ne prekine.',
        generated: 'Koda za povezavo ustvarjena',
        code_label: 'Koda za povezavo — vnesite jo v čarovnika ob prvem zagonu naprave',
        expires_in: 'Velja še {mmss}',
        expired: 'Koda je potekla — ustvarite novo.',
        hint: 'Koda velja 15 minut in samo za eno uporabo. Dolg namestitveni ukaz ostaja na voljo za skriptirane namestitve.',
    },
    sources: {
        title: 'Viri / Konektorji',
        empty: 'Instanca še ni javila stanja konektorjev.',
        col_source: 'Vir', col_category: 'Kategorija', col_state: 'Stanje',
        col_last_sync: 'Zadnja sinhronizacija', col_status: 'Status', col_count: 'Zapisov',
        state_enabled: 'Aktiven', state_disabled: 'Izklopljen', state_unconfigured: 'Ni nastavljeno',
        status_ok: 'ok', status_error: 'napaka', status_unconfigured: 'ni nastavljeno',
        status_blocked: 'blokiran', status_none: '—',
        blocked_until: 'Prijava blokirana do {at}',
        never_synced: 'Še ni sinhronizacije',
    },
    server: {
        title: 'Strežnik', no_metrics: 'Instanca še ni javila metrik strežnika.',
        cpu: 'CPU', memory: 'Pomnilnik', disk: 'Disk', load: 'Obremenitev (1 min)', uptime: 'Čas delovanja',
        warn_high: 'Visoka poraba pomnilnika ali diska', warn_crit: 'Kritična poraba pomnilnika ali diska',
        os_updates: 'Posodobitve OS', os_security: '{n} varnostnih čakajočih', os_total: '{n} skupaj',
        os_reboot: 'Ponovni zagon potreben', os_checked: 'preverjeno {rel}',
    },
    console_server: {
        title: 'Strežnik konzole', containers: 'Vsebniki',
        docker_unavailable: 'Docker ni dosegljiv na tem gostitelju — prikazane so le metrike strežnika.',
        no_containers: 'Ni vsebnikov.',
        name: 'Ime', image: 'Slika', state: 'Stanje', restarts: 'Restarti', ports: 'Vrata',
    },
    plans: {
        title: 'Paketi', new: 'Nov paket', edit: 'Uredi paket', name: 'Naziv',
        price: 'Mesečna cena (EUR)', features: 'Funkcionalnosti', features_hint: 'Ena funkcionalnost na vrstico',
        sort: 'Vrstni red', per_month: '/mes', confirm_delete: 'Res izbrišem ta paket?',
        limits_section: 'Omejitve paketa',
        limits_hint: 'Velja za VSAK paket. Pozitivno število virov naredi paket omejen; instanca omejitve uveljavi.',
        limits_zero_hint: '0 = neomejeno (velja za vsako polje).',
        modules_section: 'Moduli (regulativni režimi)',
        modules_hint: 'Kaj paket vključuje. Stranka lahko kupi NIS2, CRA ali oboje — paket samo za CRA je povsem veljaven (proizvajalec, ki sam ni zavezanec po NIS2).',
        modules_required: 'Izberite vsaj en modul. Paket brez modula stranki ne bi dal ničesar.',
        module_nis2: 'NIS2 — infrastruktura stranke',
        module_cra: 'CRA — izdelek na trgu (Uredba (EU) 2024/2847)',
        modules_unset_hint: 'Ta paket module doslej pušča odprte: konzola o njih ne pove ničesor in instance obdržijo, kar imajo. S shranjevanjem začne konzola module DOLOČATI in povozi morebitne lokalne nastavitve na instancah.',
        limited_badge: 'omejen paket', unlimited: 'Neomejeno', ai: 'AI', ai_enabled: 'AI omogočen',
        max_sources: 'Največ virov', max_users: 'Največ uporabnikov',
        max_companies: 'Največ podjetij', max_instances: 'Največ instanc',
        sum_sources: '{n} vir', sum_ai_on: 'z AI', sum_ai_off: 'brez AI',
        sum_users: '{n} uporabnikov', sum_companies: '{n} podjetij', sum_instances: '{n} instanc',
        tagline: 'Kratek opis (neobvezno)',
        tagline_hint: 'Ena vrstica za spletno stran, npr. »Za manjše ekipe, ki začenjajo z NIS2«. Prevede se skupaj z lastnostmi.',
        translations: 'Prevodi',
        translations_hint: 'Besedilo paketa v ostalih 23 jezikih EU. Slovenščina je izvirnik; ostali jeziki so prevod. Manjkajoč jezik pade na angleščino in nato na izvirnik.',
        translate_all: 'Prevedi v vse jezike',
        translate_cost_hint: 'En sam klic AI pokrije vseh 23 jezikov (ne 23 klicev). Poraba žetonov je izpisana po prevodu.',
        translate_confirm: 'Prevedem besedilo tega paketa v vseh 23 jezikov? Ročno urejeni jeziki ostanejo nedotaknjeni.',
        translate_done: 'Prevedeno: {n} jezikov (preskočeno: {skipped}), {tokens} žetonov.',
        translate_failed: 'Prevoda ni bilo mogoče izdelati.',
        translations_stale: 'Izvorno besedilo se je spremenilo — {n} samodejnih prevodov je zastarelih. Ponovno prevedite, ko boste pripravljeni.',
        translation_manual: 'ročno', translation_auto: 'samodejno',
        translation_stale: 'zastarelo', translation_missing: 'ni prevoda',
        translation_name: 'Naziv paketa (neobvezno)',
        translation_name_hint: 'Naziv paketa se NE prevaja — Free, Basic, Pro in Enterprise so imena izdelka. Izpolnite le, če ta jezik res potrebuje svoje ime.',
        translation_source: 'Izvirnik (slovenščina)',
        translation_manual_hint: 'S shranjevanjem postane ta jezik ROČEN: kasnejši prevodi z AI ga ne bodo več prepisali.',
        translation_reset: 'Odstrani prevod',
        translation_reset_confirm: 'Odstranim prevod za ta jezik? Paket bo zanj padel na angleščino oziroma na izvirnik.',
        public_api: 'Iz teh paketov se izriše cenik na spletni strani:',
        public_api_hint: 'Javen endpoint brez prijave; vrača samo javne podatke o paketih (nič internega). Odgovor se predpomni 5 minut, zato je sprememba cene na spletni strani vidna najkasneje v petih minutah. Podrobnosti so v Pomoči (Javni API za pakete).',
    },
    plan_stats: {
        // Statistika po paketih (nad karticami in na vsaki kartici)
        total_customers: 'Stranke skupaj', total_mrr: 'MRR skupaj', total_instances: 'Instance skupaj',
        plans_only: 'samo naročnine na pakete (AI se obračuna posebej)',
        no_plan: 'Brez paketa',
        no_plan_hint: 'Stranke, ki nimajo dodeljenega paketa — nihče jih ne obračunava. Klik odpre seznam teh strank.',
        no_customers: 'Nobena stranka še ni dodeljena paketu.',
        customers_n: '{n} strank', of_mrr: 'MRR',
        empty_plan: 'Na tem paketu ni nobene stranke.',
        active_n: '{n} je že javilo', silent_n: '{n} brez javljanja', instances_n: '{n} instanc',
        health_over: 'čez paket', health_near: 'blizu meje', health_underused: 'preplačuje', health_within: 'v okviru',
        averages: 'Povprečna izraba',
        averages_hint: 'Povprečje se računa samo pri strankah, katerih instance so že javile podatke; stranke brez javljanja so v skupnem številu, v povprečju pa ne. Neomejene mere nimajo razmerja in niso prikazane.',
        no_telemetry: 'Nobena stranka na tem paketu še ni javila porabe.',
        no_finite_limits: 'Paket nima končnih omejitev — izrabe ni s čim primerjati.',
    },
    releases: {
        title: 'Izdaje', new: 'Nova izdaja', edit: 'Popravi izdajo', version: 'Verzija', docker_image: 'Docker slika',
        image_hint: 'Pustite prazno — slika se sestavi iz verzije. Če jo vpišete, se mora njena oznaka ujemati z verzijo izdaje: preizkus arhitektur bere oznako iz tega polja, ne verzije, zato bi napačna oznaka poročala arhitekture druge izdaje.',
        notes: 'Opombe', published: 'Objavljeno', global_target: 'Globalna ciljna izdaja',
        status:          'Stanje',
        status_upgrading: 'Čaka na nadgradnjo instance',
        upgrading_hint:   'Konfiguracijska stopnja se NE MORE premakniti, dokler instanca ne teče na različici, ki migracijo vsebuje. Trenutno teče {version}, pripeta je na {target}. To ni zavrnitev — najprej se mora zgoditi nadgradnja, šele nato se stopnja uveljavi (običajno v minuti po tem).',
        status_idle:     'Ni cilja',
        status_waiting:  'Čaka na javljanje',
        status_applying: 'Uveljavljanje v teku',
        status_applied:  'Uveljavljeno',
        status_failed:   'Ni uspelo',
        status_stalled:  'Obtičalo',
        waiting_hint:    'Utrip, ki cilj DOSTAVI, javi stanje, kakršno je bilo PRED delom — izid lahko pride šele z naslednjim. Dokler je cilj neizpolnjen, instanca utripa vsakih 60 sekund, zato to običajno traja kakšno minuto ali dve, ne 15.',
        repair_hint:     'Naprave, ki so stopnjo 1 uveljavile na instanci 1.116.0–1.117.0, imajo pokvarjen priklop mape projekta pri posodobitvenem pomočniku: delujejo normalno, posodobiti pa se ne morejo več. Popravi stopnja 2 (instanca 1.118.0+).',
        set_target: 'Nastavi kot globalno ciljno', is_target: 'CILJNA',
        confirm_target: 'Nastavim to izdajo kot globalno ciljno za vse instance?',
        target_set: 'Globalna ciljna izdaja nastavljena', subtitle: 'Nadzorna površina za nadgradnje on-prem instanc.',
        platforms: 'Arhitekture',
        platforms_unknown: 'neznano',
        platforms_unknown_hint: 'Register nam še ni povedal, za katere arhitekture je ta izdaja objavljena. Nič ni blokirano — preverjanje se preprosto izpusti.',
        platforms_refreshed: 'Arhitekture prebrane iz registra',
        refresh_platforms: 'Znova preberi arhitekture iz registra',
        single_arch_hint: 'Objavljena samo za {arch} — instance na drugi arhitekturi te izdaje ne morejo poganjati.',
        confirm_target_stranded: 'Izdaja {version} je objavljena samo za {arches}. {count} instanc se NE bo moglo nadgraditi: {instances}. Ostale bodo na trenutni različici, dokler ne obstaja izdaja za njihovo arhitekturo. Jo kljub temu nastavim kot globalno ciljno?',
    },
    billing: {
        title: 'Obračun', subtitle: 'Mesečni prihodek po strankah.',
        customer: 'Stranka', plan: 'Paket', monthly: 'Mesečni znesek',
        total_mrr: 'Skupaj MRR', no_plan: 'Brez paketa',
        month: 'Mesec', export_csv: 'Izvozi CSV', exported: 'Izvoz pripravljen',
        plans_subtotal: 'Vmesni seštevek paketov',
        ai_title: 'Poraba in obračun AI', ai_subtitle: 'Kumulativna poraba AI žetonov po strankah, obračunana po ceniku.',
        ai_global_rate: 'Privzeti cenik', ai_input_tokens: 'Vhodni žetoni', ai_output_tokens: 'Izhodni žetoni',
        ai_rate: 'Cenik (vhod / izhod)', ai_override: 'lasten cenik', ai_amount: 'Znesek', ai_subtotal: 'Vmesni seštevek AI',
    },
    usage: {
        // Poraba glede na paket (stranka ↔ paket)
        column: 'Poraba', card_title: 'Poraba in paket',
        no_data: 'Podatkov o porabi ni.',
        no_plan_hint: 'Stranka nima paketa — poraba je prikazana, ničesar ne presojamo.',
        peak_hint: 'Stranka ima več instanc: primerja se najvišja vrednost posamezne instance, saj paket omejuje vsako instanco posebej.',
        status_over: 'čez paket', status_near: 'blizu meje', status_within: 'v okviru',
        status_over_grace: 'čez paket (odlog do {date})',
        grace_hint: 'Poraba presega paket, a instanca do {date} NIČESAR ne omejuje — samo opozarja. Po tem datumu se blokira le DODAJANJE novega (viri, uporabniki, podjetja); nič obstoječega se ne izklopi in nič ne izbriše.',
        grace_over_hint: 'Odlog (30 dni) je potekel — omejitve paketa veljajo. Blokirano je le dodajanje novega; nič obstoječega ni izklopljeno ali izbrisano.',
        status_underused: 'preplačuje', status_no_plan: 'brez paketa',
        metric_sources: 'Viri', metric_users: 'Uporabniki', metric_companies: 'Podjetja',
        metric_instances: 'Instance', metric_ai: 'AI',
        unlimited: 'neomejeno', ai_included: 'vključen', ai_not_included: 'ni v paketu',
        suggest_upgrade: 'Priporočen paket: {plan} ({price}/mes).',
        suggest_downgrade: 'Cenejši paket {plan} ({price}/mes) bi še vedno pokril vso porabo.',
        suggest_none_covers: 'Noben obstoječi paket ne pokriva te porabe — potrebna je ročna presoja.',
        incidents: 'Incidenti', reports: 'Poročila',
        incidents_delta: 'Rast incidentov',
        since_month: 'od {month}',
        only_totals: 'instance javljajo le skupne vrednosti — rast bo vidna po naslednjem mesečnem posnetku',
        ai_tokens: 'Žetoni AI', ai_this_month: 'ta mesec', ai_cumulative: 'skupno doslej (posnetka prejšnjega meseca še ni)',
        history: 'Rast po mesecih', month: 'Mesec', audit: 'Dnevnik avtomatike',
        audit_auto_upgrade: 'samodejna nadgradnja paketa',
        audit_vendor_alert: 'opozorilo ponudniku',
        audit_customer_email: 'e-pošta stranki',
        audit_grace_warn: 'opozorilo ponudniku pred iztekom odloga',
        audit_grace_customer_email: 'opozorilo stranki pred iztekom odloga',
        // Avtomatika (privolitve per stranka)
        automation_section: 'Avtomatika ob preseganju paketa',
        opt_in_email: 'Stranki pošlji predlog nadgradnje po e-pošti',
        opt_in_email_hint: 'Privzeto izklopljeno. Deluje šele, ko je v Nastavitvah vklopljeno tudi glavno stikalo. Sporočilo je v jeziku stranke, največ eno na 7 dni.',
        opt_in_auto_upgrade: 'Samodejno nadgradi paket',
        opt_in_auto_upgrade_hint: 'Privzeto izklopljeno. Ob preseganju paket dvigne na najcenejšega, ki pokrije porabo; sprememba se vedno zabeleži in sporoči ponudniku.',
        // Tabela na Obračunu
        table_title: 'Poraba glede na paket',
        table_hint: 'Kaj stranke dejansko uporabljajo v primerjavi s tem, kar plačujejo. Zajeto iz javljanja instanc (check-in).',
        issues: 'Odstopanja', suggestion: 'Predlog', current_plan: 'Trenutni paket',
        run_sweep: 'Preveri porabo zdaj',
        sweep_done: 'Pregled končan: {customers} strank, {over} čez paket, {near} blizu meje, {underused} preplačuje.',
        sweep_mails: 'Poslanih opozoril ponudniku: {vendor}; e-pošte strankam: {customer}; samodejnih nadgradenj: {upgrades}.',
        sweep_failed: 'Pregled porabe ni uspel',
        generated_at: 'Osveženo: {time}',
        kpi_line: 'Čez paket: {over} (od tega v odlogu: {grace}) · blizu meje: {near} · preplačuje: {underused}',
        sweep_grace: 'Odlog: {started} novih, {cleared} preklicanih, {warnings} opozoril pred iztekom.',
        only_attention: 'Samo odstopanja',
        no_attention: 'Vse stranke so v okviru svojih paketov.',
    },
    users: {
        title: 'Uporabniki', new: 'Nov uporabnik', edit: 'Uredi uporabnika',
        name: 'Ime', username: 'Uporabniško ime', password: 'Geslo',
        password_hint: 'Pustite prazno, če gesla ne želite spremeniti.',
        role: 'Vloga', role_admin: 'Skrbnik', role_viewer: 'Pregledovalec', role_instalater: 'Inštalater',
        email: 'E-naslov', language: 'Jezik', you: 'vi',
        confirm_delete: 'Res izbrišem tega uporabnika?',
    },
    dns: {
        orphans_title: 'Osiroteli DNS zapisi',
        orphans_hint: 'Zapisi v poddomeni za instance, ki jim ne pripada nobena obstoječa instanca. Zapisi, ki so osiroteli več kot 7 dni, se odstranijo samodejno; mlajše je treba potrditi ročno (da med selitvijo ne pobrišemo česa v uporabi). Zapisi izven poddomene za instance se nikoli ne prikažejo in jih ni mogoče brisati.',
        orphans_name: 'Zapis', orphans_type: 'Vrsta', orphans_content: 'Vsebina', orphans_age: 'Osirotel',
        orphans_days: '{n} dni', orphans_auto: 'samodejno brisanje',
        orphans_cleanup: 'Počisti osirotele zapise',
        orphans_confirm: 'Res odstranim vse naštete osirotele zapise iz cone? Tega ni mogoče razveljaviti.',
        orphans_removed: 'Odstranjenih zapisov: {n}',
    },

    appliance: {
        title:      'Konfiguracija naprave',
        reported:   'Javljena stopnja',
        target:     'Cilj',
        no_target:  'Ni cilja',
        set_target: 'Nastavi ciljno stopnjo',
        failed:     'Naprava spremembe ni mogla uveljaviti',
        hint:       'Konzola pošlje SAMO številko stopnje — nikoli vsebine datoteke. Naprava uveljavi le tiste spremembe, ki jih njena lastna koda pozna, rezultat preveri na svojih kontejnerjih in se ob neuspehu vrne na prejšnje stanje. Ponovna uveljavitev iste stopnje ne naredi ničesar. Nastavlja se za VSAKO instanco posebej; skupnega stikala za vso floto namenoma ni.',
    },
    registry_credential: {
        title:            'Poverilnica registra',
        delivery:         'Dostava prek prijave (check-in)',
        delivery_on:      'Vklopljeno',
        delivery_off:     'Izklopljeno',
        delivery_hint:    'Dokler je izklopljeno, konzola tej instanci ne pošlje ničesar. Kasnejši izklop poverilnice NE odvzame — naprava obdrži tisto, ki jo že uporablja.',
        held:             'Instanca ima',
        current:          'Trenutna v konzoli',
        never:            'Nikoli dostavljeno (poverilnica iz namestitve)',
        not_configured:   'Konzola nima nastavljene poverilnice registra (REGISTRY_PULL_USER / REGISTRY_PULL_PASSWORD), zato ni česa dostaviti in ni s čim primerjati.',
        status:           'Stanje',
        status_off:       'Ni dostavljeno',
        status_applying:  'Uveljavljam',
        status_held:      'Ima in preverjeno',
        status_stalled:   'Obtičalo',
        status_failed:    'Zavrnjeno — ostaja na prejšnji poverilnici',
        status_waiting:   'Čakam, da instanca javi',
        match:            'Ta naprava je dokazljivo na trenutni poverilnici.',
        mismatch:         'Ta naprava NI na trenutni poverilnici. Zamenjava zdaj bi jo pustila brez posodobitev.',
        failed:           'Naprava poverilnice ni mogla prevzeti',
        waiting_hint:     'Utrip, ki poverilnico DOSTAVI, javi stanje, kakršno je bilo PRED delom — izid pride z naslednjim.',
        hint:             'Poverilnica potuje SAMO v overjenem odgovoru prijave (check-in): nikoli v ISO, nikoli v naslovu, nikoli v dnevniku. Naprava z novo poverilnico najprej preveri pravi prenos slike (pull) IN ŠELE NATO zamenja delujočo, po zamenjavi preveri še enkrat, ob neuspehu pa se vrne na staro. Ponovni prejem iste poverilnice ne naredi ničesar. Nastavlja se za VSAKO instanco posebej; skupnega stikala za vso floto namenoma ni.',
        proof_hint:       'Prikazana generacija je tista, ki jo instanca JAVLJA, da jo ima — ne tista, ki smo jo poslali. Prav v tem je bistvo: zamenjava je varna šele, ko vse naprave javijo trenutno generacijo.',
    },
    tls: {
        title: 'HTTPS / Dostop',
        not_configured: 'TLS ni nastavljeno. Konzola nima poverilnic za Cloudflare (CLOUDFLARE_DNS_API_TOKEN in CLOUDFLARE_ZONE), zato certifikatov ni mogoče izdajati.',
        status_none: 'Ni nastavljeno', status_issued: 'Izdano, poteče čez {n} dni', status_error: 'Napaka',
        staging: 'TESTNI (staging) certifikat',
        staging_option: 'Uporabi testno okolje Let\'s Encrypt (staging) — brskalnik mu ne bo zaupal',
        hostname: 'Ime gostitelja', hostname_hint: 'Prazno = samodejno iz imena instance, pod {suffix}. Ime lahko spremenite le pred prvo izdajo.',
        ip: 'Naslov v lokalnem omrežju (A zapis)',
        ip_hint: 'Naslov, na katerega kaže DNS. Prazno = naslov, ki ga instanca javi sama.',
        issue: 'Izdaj', renew: 'Obnovi', disable: 'Onemogoči',
        disable_confirm: 'Certifikat bo ob naslednjem javljanju odstranjen z instance, obnavljanje se ustavi. Instanca bo še naprej dostopna po HTTP. Nadaljujem?',
        issued: 'Certifikat izdan — instanca ga prejme ob naslednjem javljanju.',
        renewed: 'Certifikat obnovljen.',
        disabled: 'HTTPS onemogočen.',
        expires: 'Poteče', days_left: '{n} dni', dns_record: 'Objavljen A zapis', reported_ip: 'Naslov, ki ga javi instanca',
        hint: 'Certifikat izda konzola (Let\'s Encrypt, preverjanje prek DNS v naši coni) in ga instanci dostavi po varnem kanalu javljanja. Instanca ne potrebuje odprtih vrat iz interneta. Obnavljanje teče samodejno 30 dni pred potekom.',
        ip_auto: 'samodejno',
        ip_manual: 'ročno',
        ip_updated: 'Naslov posodobljen ob {at} ({from} → {to}). Certifikat velja naprej — vezan je na ime, ne na naslov.',
        ip_unstable: 'Instanca prepogosto spreminja naslov (več kot 6 sprememb na uro), zato je zapis začasno pri miru. Priporočilo: rezervirajte naslov v DHCP ali vpišite fiksen naslov spodaj.',
        pin_ip: 'Fiksen naslov (neobvezno)',
        pin: 'Pripni naslov', unpin: 'Sprosti (samodejno)',
        pin_hint: 'Pripeti naslov izklopi samodejno sledenje naslovu, ki ga javlja instanca — uporabno pri statičnem naslovu ali NAT. Prazno polje pripne trenutno objavljeni naslov.',
        pinned: 'Naslov pripet — samodejno sledenje izklopljeno.',
        unpinned: 'Samodejno sledenje naslovu vklopljeno.',
    },
    install: {
        title: 'Namestitev',
        intro: 'Ustvari namestitveni ukaz za to instanco. Ukaz zaženite kot root na svežem strežniku (Debian 13) — sam si namesti curl, postavi celoten ComplyIT sklad in ga poveže s to konzolo. Predhodni curl ali sudo nista potrebna. Ukaz je večkraten: velja do prve namestitve (prvega javljanja instance) ali 48 ur, kar nastopi prej.',
        generate: 'Generiraj installer',
        key_warning: 'Ustvarjanje novega ključa RAZVELJAVI prejšnjega: star namestitveni ukaz preneha delovati, instanca, ki že teče s starim ključem, pa se bo NEHALA javljati, dokler je ne povežete znova.',
        command_label: 'Zaženite na ciljnem strežniku (kot root):',
        expires: 'Ukaz velja do prve namestitve ali {at} (48 ur) — do takrat ga lahko poženete večkrat.',
        vm_hint: 'Nimate strežnika? Pripravljena VM slika (Debian 13, DHCP):',
        vm_link: 'Prenesi VM sliko',
        netreq_title: 'Zahteve omrežja',
        netreq_intro: 'Strežnik ComplyIT potrebuje izhodni dostop TCP 443 do naslednjih domen (in DNS na vratih 53):',
        netreq_domains_label: 'Domene (izhodni TCP 443):',
        netreq_rule_allow: 'Dovoli te domene v web-filtru požarnega zidu (sicer proxy vrne HTTP 403).',
        netreq_rule_inspect: 'Izvzemi te domene iz SSL/TLS inšpekcije (dešifriranja) — MITM zlomi docker login/pull in curl. Če inšpekcije ni mogoče izklopiti, na strežnik namesti inšpekcijski root CA (/usr/local/share/ca-certificates + update-ca-certificates).',
        netreq_lan_note: 'Namestitev proti internemu registru v istem LAN-u (npr. 192.168.x.x:5000) tega ne potrebuje.',
        generated: 'Namestitveni ukaz ustvarjen',
        generate_confirm: 'Generiranje razveljavi prejšnji ključ instance in prejšnji namestitveni ukaz. Nadaljujem?',
        status_waiting: 'čaka na prvo javljanje',
        status_done: 'nameščeno',
        remote_title: 'Namesti oddaljeno',
        remote_intro: 'Vnesite naslov in SSH poverilnice ciljnega strežnika. Konzola se bo povezala prek SSH in zagnala namestitev — napredek se izpisuje v živo spodaj.',
        remote_host: 'Naslov (IP ali gostitelj)',
        remote_port: 'Vrata',
        remote_user: 'Uporabnik',
        remote_password: 'Geslo',
        remote_user_hint: 'Root način: prijava neposredno kot root.',
        remote_mode: 'Način dostopa',
        remote_mode_hint: 'Debian privzeto onemogoči prijavo root prek SSH z geslom (PermitRootLogin prohibit-password), zato je na tipičnem strežniku pravi način »navadni uporabnik + su«.',
        remote_mode_root: 'root (neposredno)',
        remote_mode_su: 'navadni uporabnik + su',
        remote_su_user: 'Uporabnik (prijava)',
        remote_su_password: 'Geslo uporabnika',
        remote_su_root_password: 'Geslo za root (su)',
        remote_warning: 'Cilj mora biti dosegljiv s strežnika konzole (javni IP ali VPN). Gesla se uporabijo le za povezavo in se NE shranijo.',
        remote_run: 'Zaženi namestitev',
        remote_confirm: 'Namestitev razveljavi prejšnji ključ instance in zažene sklad na ciljnem strežniku. Nadaljujem?',
        remote_started: 'Oddaljena namestitev se je začela',
        remote_running: 'V teku',
        remote_success: 'Uspešno',
        remote_failed: 'Neuspešno',
        remote_log_label: 'Dnevnik namestitve',
        remote_no_log: 'Čakam na izpis …',
    },
    health: { ok: 'V redu', degraded: 'Poslabšano', error: 'Napaka', unknown: 'Neznano', stale: 'Nedosegljiva' },
}
